<template>
  <div>
    <b-autocomplete
      v-model="user"
      :items="$directory.get('userList')"
      :loading="$loading.isLoading('userList')"
      :error-messages="getErrorMessages(v$.user)"
      :item-title="getPersonName"
      return-object
      placeholder="оберіть користувача"
      @blur="v$.user.$touch()"></b-autocomplete>
  </div>
</template>

<script lang="ts">
import { getErrorMessages, getPersonName } from 'best-modules/utils'
import { ref } from 'vue'
import { fillDirectory } from '@/directory'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'UserSelect',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getPersonName, getErrorMessages },
  setup() {
    fillDirectory('userList')
    const user = ref()

    const v$ = useVuelidate({ user: { required } }, { user })

    const submit = () => {
      return Promise.resolve(user.value)
    }

    return { user, v$, submit }
  },
}
</script>

<style scoped></style>
